// ── Store support configuration ───────────────────────────────────────────────
//
// status:
//   'full'         — prices live in app, full comparison available
//   'partial'      — some products covered, expanding
//   'coming_soon'  — store recognised by receipt scanner, prices not yet live
//
// Update this file as stores are added to the price sheet.
// ─────────────────────────────────────────────────────────────────────────────

export const STORE_CONFIG = {
  store_tesco:      { name: 'Tesco',        status: 'full'        },
  store_sainsburys: { name: "Sainsbury's",   status: 'full'        },
  store_lidl:       { name: 'Lidl',          status: 'full'        },
  store_aldi:       { name: 'Aldi',          status: 'full'        },
  store_asda:       { name: 'Asda',          status: 'coming_soon' },
  store_waitrose:   { name: 'Waitrose',      status: 'coming_soon' },
  store_morrisons:  { name: 'Morrisons',     status: 'coming_soon' },
  store_ms:         { name: 'M&S',           status: 'coming_soon' },
  store_iceland:    { name: 'Iceland',       status: 'coming_soon' },
  store_coop:       { name: 'Co-op',         status: 'coming_soon' },
};

// Helper — returns true if the store has full or partial price coverage
export const storeIsSupported = (storeId) => {
  const cfg = STORE_CONFIG[storeId];
  return cfg?.status === 'full' || cfg?.status === 'partial';
};

// Helper — returns a human-readable store name
export const getStoreName = (storeId) => {
  return STORE_CONFIG[storeId]?.name
    || storeId?.replace(/^store_/, '').replace(/\b\w/g, c => c.toUpperCase())
    || 'Unknown store';
};

// All stores with coming_soon status — shown as ghost rows in price comparison
export const COMING_SOON_STORES = Object.entries(STORE_CONFIG)
  .filter(([, cfg]) => cfg.status === 'coming_soon')
  .map(([id, cfg]) => ({ id, name: cfg.name }));
